/**
 * Component to load alternative offers and show result
 */
define([
    'jQuery',
    'underscore',
    'library/fcse-compatibility/object',
    'library/fcse-component/optionsMixin',
    'library/fcse-util/url',
    'library/fcse-util/paramConverter',
    'library/fcse-events/eventDispatcher',
    'clientComponents/alternatives/alternativesLoadMoreButton'
    ],
    /**
     *
     * @param $
     * @param _
     * @param Object
     * @param OptionsMixin
     * @param Url
     * @param ParamConverter
     * @param EventDispatcher
     * @param {AlternativesLoadMoreButton} AlternativesLoadMoreButton
     * @returns {FlightAlternatives}
     */
    function($, _, Object, OptionsMixin, Url, ParamConverter, EventDispatcher, AlternativesLoadMoreButton) {
        /**
         * Creates an alternatives button
         *
         * @param element jQuery selector or DOM element
         * @param {MultiRequestHandler} requestHandler
         * @param {object} options
         * @constructor
         */
        var FlightAlternatives = function (element, requestHandler, options) {
            // Call Constructor of parent class
            EventDispatcher.apply(this, arguments);

            // Set elements
            this.element = $(element);
            this.requestHandler = requestHandler;

            // Add default options and custom options
            this.addOptions({}, options);
            this._init();
        };

        FlightAlternatives.prototype = $.extend(Object.create(EventDispatcher.prototype), OptionsMixin, {
            /**
             * Initializer
             * @private
             */
            _init: function() {
                new AlternativesLoadMoreButton(
                    this.element.find('[data-fcse-role="alternatives-load-more-button"]'),
                    this.requestHandler, {
                        flightAlternatives: this.element,
                        openerSelector: '[data-fcse-role="alternatives-button"]'
                    }
                );
            }
        });

        return FlightAlternatives;
    }
);



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/alternatives/flightAlternatives.js